export const PAGE_MOTION = {
  mode: 'out-in',
  enterActiveClass: 'animate-in fade-in-0 slide-in-from-bottom-1 duration-200 ease-out',
  leaveActiveClass: 'animate-out fade-out-0 duration-75 ease-in',
} as const

export const CONTENT_MOTION = {
  mode: 'out-in',
  enterActiveClass: 'animate-in fade-in-0 duration-200 ease-out',
  leaveActiveClass: 'animate-out fade-out-0 duration-100 ease-in',
} as const

export const ROW_MOTION = {
  appear: true,
  enterActiveClass: 'animate-in fade-in-0 duration-200 ease-out',
  moveClass: 'transition-transform duration-200 ease-out',
} as const
